// ---------------------------------------------------------------------------
// Mirrors the consistent error shape from spec §8.0. Backend wraps every
// non-success response as `{ "error": { code, message, request_id, details } }`.
// This module hydrates that shape into a typed ApiError class.
// ---------------------------------------------------------------------------

import type { ApiErrorBody, ApiErrorCode } from "./types";

export class ApiError extends Error {
  constructor(
    public readonly code: ApiErrorCode | "UNKNOWN",
    message: string,
    public readonly status: number,
    public readonly request_id?: string,
    public readonly details?: Record<string, unknown>,
  ) {
    super(message);
    this.name = "ApiError";
  }

  static fromResponse(status: number, body: unknown): ApiError {
    if (
      typeof body === "object" &&
      body !== null &&
      "error" in body &&
      typeof (body as { error: unknown }).error === "object" &&
      (body as { error: object }).error !== null
    ) {
      const err = (body as { error: ApiErrorBody }).error;
      return new ApiError(err.code, err.message, status, err.request_id, err.details);
    }
    return new ApiError("UNKNOWN", "An unknown error occurred", status);
  }
}
